// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ComingSoon.css */
.coming-soon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(to right, #ff7e5f, #feb47b); /* Gradient background */
  }
  
  .coming-soon-box {
    text-align: center;
    background-color: #ffffff;
    padding: 40px 50px;
    border-radius: 15px;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.1);
    transform: scale(0.9);
    animation: scale-up 0.5s ease-out forwards;
  }
  
  .coming-soon-header {
    font-size: 3rem;
    font-weight: bold;
    color: #65449b;
    text-transform: uppercase;
    animation: fadeIn 2s ease-out;
  }
  
  .coming-soon-subheader {
    font-size: 1.2rem;
    color: #333;
    margin-top: 10px;
  }
  
  .coming-soon-animation {
    margin-top: 20px;
  }
  
  .dot {
    display: inline-block;
    width: 15px;
    height: 15px;
    background-color: #65449b;
    margin: 0 8px;
    border-radius: 50%;
    animation: bounce 1.2s infinite;
  }
  
  .dot:nth-child(1) {
    animation-delay: 0s;
  }
  
  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  .coming-soon-message {
    font-size: 1.5rem;
    color: #ff7e5f;
    margin-top: 30px;
    font-style: italic;
    animation: fadeIn 3s ease-out;
  }
  
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes scale-up {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/views/utilities/tables/comingSoon/ComingSoon.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uDAAuD,EAAE,wBAAwB;EACnF;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,qBAAqB;MACrB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,2BAA2B;IAC7B;EACF","sourcesContent":["/* ComingSoon.css */\n.coming-soon-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background: linear-gradient(to right, #ff7e5f, #feb47b); /* Gradient background */\n  }\n  \n  .coming-soon-box {\n    text-align: center;\n    background-color: #ffffff;\n    padding: 40px 50px;\n    border-radius: 15px;\n    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.1);\n    transform: scale(0.9);\n    animation: scale-up 0.5s ease-out forwards;\n  }\n  \n  .coming-soon-header {\n    font-size: 3rem;\n    font-weight: bold;\n    color: #65449b;\n    text-transform: uppercase;\n    animation: fadeIn 2s ease-out;\n  }\n  \n  .coming-soon-subheader {\n    font-size: 1.2rem;\n    color: #333;\n    margin-top: 10px;\n  }\n  \n  .coming-soon-animation {\n    margin-top: 20px;\n  }\n  \n  .dot {\n    display: inline-block;\n    width: 15px;\n    height: 15px;\n    background-color: #65449b;\n    margin: 0 8px;\n    border-radius: 50%;\n    animation: bounce 1.2s infinite;\n  }\n  \n  .dot:nth-child(1) {\n    animation-delay: 0s;\n  }\n  \n  .dot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  \n  .dot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  .coming-soon-message {\n    font-size: 1.5rem;\n    color: #ff7e5f;\n    margin-top: 30px;\n    font-style: italic;\n    animation: fadeIn 3s ease-out;\n  }\n  \n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes scale-up {\n    0% {\n      transform: scale(0.7);\n      opacity: 0;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n  \n  @keyframes bounce {\n    0%, 20%, 50%, 80%, 100% {\n      transform: translateY(0);\n    }\n    40% {\n      transform: translateY(-10px);\n    }\n    60% {\n      transform: translateY(-5px);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
